import { hasCompletedOnboarding } from './preferences';

// ReadinessSelector values. A stored answer is what "onboarding was answered" means.
const READINESS_ANSWERS = new Set(['spark', 'fragments', 'concept', 'formed']);

/**
 * Skip Step 0 on the first book only when onboarding was actually answered.
 *
 * hasCompletedOnboarding() is stubbed to true while onboarding is off, so it
 * is not an answer by itself. The skip stays dormant until a ReadinessSelector
 * value is stored on the session. Later books are asked either way.
 */
export function onboardingAnswerSkipsStep0({ isFirstBook, readiness } = {}) {
  if (!isFirstBook) return false;
  if (typeof readiness !== 'string' || !READINESS_ANSWERS.has(readiness)) return false;
  return hasCompletedOnboarding();
}

/**
 * Show the Step 0 card in an empty book Discovery chat.
 * New books and series books qualify. Imported books, a dismissed card,
 * and the onboarding first-book skip do not. Never a block.
 */
export function shouldOfferStep0({
  isDiscovery = false,
  isEmpty = false,
  hasPathGapOpener = false,
  storyId = null,
  step0Asked = false,
  bookImported = false,
  isFirstBook = false,
  readiness = null,
} = {}) {
  if (!isDiscovery || !isEmpty || hasPathGapOpener) return false;
  if (!storyId) return false;
  if (step0Asked || bookImported) return false;
  if (onboardingAnswerSkipsStep0({ isFirstBook, readiness })) return false;
  return true;
}
